import { render } from "./DeleteDocumentDialog.vue?vue&type=template&id=32a39e02&scoped=true&ts=true&lang=pug"
import script from "./DeleteDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteDocumentDialog.vue?vue&type=script&lang=ts"

import "./DeleteDocumentDialog.vue?vue&type=style&index=0&id=32a39e02&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a39e02"]])

export default __exports__